export const BUILDING_INFO_SOURCE_MEANINGS = {
    Geoscape: 'This value is provided by Geoscape.',
    'User supplied': 'A user entered this value.',
    'Unit default': 'This value defaults to one lot for a unit.',
} as const;
